import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isUrlInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.URL_INPUT && typeof label === 'string' && typeof value === 'string';
}
function _formatUrlInput(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatUrlInput(submission) {
  if (isUrlInput(submission)) {
    return _formatUrlInput(submission);
  }
  return undefined;
}
//# sourceMappingURL=url-input-preview.js.map